import '@rei/cedar/dist/cdr-reset.css';
import '@rei/cedar/dist/cdr-fonts.css';

import '@rei/cedar/dist/style/cdr-container.css';
import '@rei/cedar/dist/style/cdr-text.css';
import '@rei/cedar/dist/style/cdr-button.css';
import '@rei/cedar/dist/style/cdr-input.css';
import '@rei/cedar/dist/style/cdr-icon.css';
import '@rei/cedar/dist/style/cdr-link.css';

import createApp from '@order-lookup/main.mts';
import type { PageData } from '@order-lookup/types/index.mts';
import vAnalytics from '@directives/v-analytics.mts';
import MiniTray from '@plugins/MiniTray/MiniTray';
import { getClientPageData } from '@utils/helpers.mts';

const { pageData: props } = getClientPageData<PageData>();

const { app } = createApp(props);
app.directive('analytics', vAnalytics);
app.use(MiniTray);
app.mount('#app');
